/** General nav labels in Clerk localization (en + he). */
export const CLERK_ORG_GENERAL_NAV_LABELS = ['General', 'כללי'] as const;

/** Members nav labels in Clerk localization (en + he). */
export const CLERK_ORG_MEMBERS_NAV_LABELS = ['Members', 'חברים'] as const;

/** Delete section labels in Clerk localization (en + he). */
export const CLERK_ORG_DELETE_SECTION_LABELS = ['Delete organization', 'מחק ארגון'] as const;

/** Leave section labels in Clerk localization (en + he). */
export const CLERK_ORG_LEAVE_SECTION_LABELS = ['Leave organization', 'עזוב את הארגון'] as const;

/** Modal title in Clerk localization (en + he). */
export const CLERK_ORG_MODAL_TITLE_LABELS = {
  en: 'Manage Organization',
  he: 'נהל ארגון',
} as const;

/** Mobile org profile: custom tab bar; fully hide Clerk burger drawer. */
export const CLERK_ORG_PROFILE_MOBILE_TAB_RULES = `
  .cl-organizationProfile-root:not([data-kw-org-nav-caching]) .cl-navbarMobileMenuButton,
  .cl-organizationProfile-root:not([data-kw-org-nav-caching]) [class*='navbarMobileMenuButton'],
  .cl-organizationProfile-root:not([data-kw-org-nav-caching]) .cl-navbar,
  .cl-organizationProfile-root:not([data-kw-org-nav-caching]) .cl-navbarButtons,
  .cl-organizationProfile-root:not([data-kw-org-nav-caching]) [class*='navbarButtons'],
  .cl-organizationProfile-root:not([data-kw-org-nav-caching]) [class*='navbarMobileMenu']:not([class*='navbarMobileMenuRow']) {
    display: none !important;
  }

  .cl-organizationProfile-root .cl-navbarMobileMenuRow,
  .cl-organizationProfile-root [class*='navbarMobileMenuRow'] {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    min-height: 2.75rem !important;
    padding-inline: 2.75rem !important;
    border-bottom: none !important;
    background: transparent !important;
  }

  .cl-organizationProfile-root .cl-headerTitle,
  .cl-organizationProfile-root [class*='headerTitle']:not([class*='profilePageHeader']) {
    display: block !important;
    font-size: 0.9375rem !important;
    font-weight: 600 !important;
    line-height: 1.25rem !important;
    text-align: center !important;
    color: rgb(17 24 39) !important;
  }

  .dark .cl-organizationProfile-root .cl-headerTitle,
  .dark .cl-organizationProfile-root [class*='headerTitle']:not([class*='profilePageHeader']) {
    color: rgb(243 244 246) !important;
  }

  .kw-org-mobile-modal-title {
    flex: 1;
    text-align: center;
    font-size: 0.9375rem;
    font-weight: 600;
    line-height: 1.25rem;
    color: rgb(17 24 39);
  }

  .dark .kw-org-mobile-modal-title {
    color: rgb(243 244 246);
  }

  .cl-organizationProfile-root .cl-rootBox,
  .cl-organizationProfile-root .cl-cardBox {
    display: flex !important;
    flex-direction: column !important;
  }

  .kw-org-mobile-tab-bar {
    display: flex;
    flex-shrink: 0;
    width: 100%;
    border-bottom: 1px solid rgb(229 231 235);
    background: rgb(255 255 255);
    position: relative;
    z-index: 2;
  }

  .dark .kw-org-mobile-tab-bar {
    border-bottom-color: rgb(55 65 81);
    background: rgb(17 24 39);
  }

  .kw-org-mobile-tab-bar button {
    flex: 1 1 0;
    margin: 0;
    padding: 0.625rem 0.5rem;
    border: none;
    border-bottom: 2px solid transparent;
    border-radius: 0;
    background: transparent;
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1.25rem;
    color: rgb(107 114 128);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .dark .kw-org-mobile-tab-bar button {
    color: rgb(156 163 175);
  }

  .kw-org-mobile-tab-bar button[data-kw-org-tab-active='true'] {
    color: rgb(17 24 39);
    font-weight: 600;
    border-bottom-color: rgb(16 185 129);
  }

  .dark .kw-org-mobile-tab-bar button[data-kw-org-tab-active='true'] {
    color: rgb(243 244 246);
    border-bottom-color: rgb(52 211 153);
  }

  .cl-organizationProfile-root .cl-pageScrollBox > *:first-child [class*='headerTitle'],
  .cl-organizationProfile-root [class*='profilePageHeader'] {
    display: none !important;
  }
`.trim();

/**
 * Mobile-only overrides for Clerk's OrganizationProfile modal (`openOrganizationProfile`).
 * Scoped to `.cl-modalContent:has(.cl-organizationProfile-root)` so embedded
 * `/settings/organization` and desktop modals stay unchanged.
 */
export const CLERK_ORG_PROFILE_MOBILE_CSS = `
@media (max-width: 767px) {
  .cl-modalContent:has(.cl-organizationProfile-root [class*='membersPage']),
  .cl-modalContent:has(.cl-organizationProfile-root [class*='invitationsPage']) {
    width: min(calc(100vw - 1rem), 36rem) !important;
    max-height: min(85dvh, 34rem) !important;
    height: auto !important;
    margin: auto !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root [class*='membersPage']) .cl-organizationProfile-root,
  .cl-modalContent:has(.cl-organizationProfile-root [class*='invitationsPage']) .cl-organizationProfile-root,
  .cl-modalContent:has(.cl-organizationProfile-root [class*='membersPage']) .cl-organizationProfile-root .cl-cardBox,
  .cl-modalContent:has(.cl-organizationProfile-root [class*='invitationsPage']) .cl-organizationProfile-root .cl-cardBox,
  .cl-modalContent:has(.cl-organizationProfile-root [class*='membersPage']) .cl-organizationProfile-root .cl-card,
  .cl-modalContent:has(.cl-organizationProfile-root [class*='invitationsPage']) .cl-organizationProfile-root .cl-card {
    max-height: min(85dvh, 34rem) !important;
    height: auto !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root [class*='membersPage']) .cl-organizationProfile-root .cl-scrollBox,
  .cl-modalContent:has(.cl-organizationProfile-root [class*='invitationsPage']) .cl-organizationProfile-root .cl-scrollBox,
  .cl-modalContent:has(.cl-organizationProfile-root [class*='membersPage']) .cl-organizationProfile-root .cl-pageScrollBox,
  .cl-modalContent:has(.cl-organizationProfile-root [class*='invitationsPage']) .cl-organizationProfile-root .cl-pageScrollBox {
    max-height: calc(min(85dvh, 34rem) - 7rem) !important;
    height: calc(min(85dvh, 34rem) - 7rem) !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root):not(:has([class*='membersPage'])):not(:has([class*='invitationsPage'])) {
    width: min(100vw - 1.5rem, 24rem) !important;
    max-height: min(80dvh, 30rem) !important;
    height: auto !important;
    margin: auto !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root):not(:has([class*='membersPage'])):not(:has([class*='invitationsPage'])) .cl-organizationProfile-root,
  .cl-modalContent:has(.cl-organizationProfile-root):not(:has([class*='membersPage'])):not(:has([class*='invitationsPage'])) .cl-organizationProfile-root .cl-cardBox,
  .cl-modalContent:has(.cl-organizationProfile-root):not(:has([class*='membersPage'])):not(:has([class*='invitationsPage'])) .cl-organizationProfile-root .cl-card {
    max-height: min(80dvh, 30rem) !important;
    height: auto !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root):not(:has([class*='membersPage'])):not(:has([class*='invitationsPage'])) .cl-organizationProfile-root .cl-scrollBox,
  .cl-modalContent:has(.cl-organizationProfile-root):not(:has([class*='membersPage'])):not(:has([class*='invitationsPage'])) .cl-organizationProfile-root .cl-pageScrollBox {
    max-height: calc(min(80dvh, 30rem) - 7rem) !important;
    height: calc(min(80dvh, 30rem) - 7rem) !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    flex: 1 1 auto !important;
    min-height: 0 !important;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root):not(:has([class*='membersPage'])):not(:has([class*='invitationsPage'])) .cl-organizationProfile-root .cl-scrollBox::-webkit-scrollbar,
  .cl-modalContent:has(.cl-organizationProfile-root):not(:has([class*='membersPage'])):not(:has([class*='invitationsPage'])) .cl-organizationProfile-root .cl-pageScrollBox::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root):not(:has([class*='membersPage'])):not(:has([class*='invitationsPage'])) .cl-organizationProfile-root .cl-pageScrollBox {
    display: flex !important;
    flex-direction: column !important;
    gap: 0.5rem !important;
    padding-bottom: 0.75rem !important;
    min-height: 100% !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root .cl-profileSection,
  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root [data-clerk-element="profileSection"] {
    padding-block: 0.5rem !important;
    gap: 0.375rem !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root .cl-header,
  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root .cl-pageHeader {
    padding-block: 0.625rem !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root [data-clerk-element="profileSectionTitle"]:empty {
    display: none !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root [data-kw-org-delete-section="true"] {
    margin-top: auto !important;
    align-items: center !important;
    text-align: center !important;
    border-top: none !important;
    padding-top: 0.25rem !important;
    opacity: 0.72;
  }

  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root [data-kw-org-delete-section="true"] [class*="profileSectionTitle"],
  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root [data-kw-org-delete-section="true"] [data-clerk-element="profileSectionTitle"] {
    display: none !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root [data-kw-org-delete-section="true"] button,
  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root [data-kw-org-delete-section="true"] a {
    font-size: 0.6875rem !important;
    line-height: 1.25rem !important;
    font-weight: 500 !important;
    justify-content: center !important;
    margin-inline: auto !important;
    opacity: 0.85;
  }

  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root [data-kw-org-leave-section="true"] [class*="profileSectionTitle"],
  .cl-modalContent:has(.cl-organizationProfile-root) .cl-organizationProfile-root [data-kw-org-leave-section="true"] [data-clerk-element="profileSectionTitle"] {
    display: none !important;
  }

  .cl-modalContent:has(.cl-organizationProfile-root) [data-clerk-dev-mode-notice],
  .cl-modalContent:has(.cl-organizationProfile-root) [data-clerk-dev-mode-overlay] {
    display: none !important;
  }

  ${CLERK_ORG_PROFILE_MOBILE_TAB_RULES}
}
`.trim();

/** Mobile-only overrides for embedded `/settings/organization`. */
export const CLERK_ORG_PROFILE_EMBEDDED_MOBILE_CSS = `
@media (max-width: 767px) {
  .reach-organization-settings-shell [data-clerk-dev-mode-notice],
  .reach-organization-settings-shell [data-clerk-dev-mode-overlay] {
    display: none !important;
  }

  ${CLERK_ORG_PROFILE_MOBILE_TAB_RULES}
}
`.trim();

export function isMobileViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(max-width: 767px)').matches;
}

export function getClerkOrganizationProfileMobileAppearance() {
  return {
    elements: {
      modalContent: {
        maxHeight: 'min(80dvh, 30rem)',
        height: 'auto',
      },
      cardBox: {
        maxHeight: 'min(80dvh, 30rem)',
        height: 'auto',
      },
      scrollBox: {
        maxHeight: 'calc(min(80dvh, 30rem) - 7rem)',
        height: 'calc(min(80dvh, 30rem) - 7rem)',
      },
      pageScrollBox: {
        minHeight: '100%',
      },
    },
  };
}
